/*
 * @Description: '结局方案'页面所有路由
 * @Author: 任录
 * @Date: 2019-07-22 16:50:00
 * @LastEditTime: 2019-07-25 10:12:42
*/

export default [
    {
        path: 'privacy',
        component: resolve => require(['@/views/privacy'], resolve),
        name: 'Privacy',
        meta: {
            nav: 'Privacy'
        }
    }

]


// WEBPACK FOOTER //
// ./src/router/privacy.js